import { Alert, Button, Modal, Space, Typography } from 'antd';
import { useT } from '../../../locales';

export interface TemporaryPasswordModalProps {
  open: boolean;
  tempPassword: string | null;
  onAcknowledge: () => void;
}

export function TemporaryPasswordModal({
  open,
  tempPassword,
  onAcknowledge,
}: TemporaryPasswordModalProps) {
  const t = useT();

  return (
    <Modal
      open={open && tempPassword !== null}
      title={t('pages.users.temporaryPasswordTitle')}
      closable={false}
      mask={{ closable: false }}
      keyboard={false}
      centered
      footer={
        <Button type="primary" onClick={onAcknowledge}>
          {t('pages.users.temporaryPasswordAcknowledge')}
        </Button>
      }
      destroyOnHidden
    >
      <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
        <Typography.Paragraph>{t('pages.users.temporaryPasswordDescription')}</Typography.Paragraph>
        <Typography.Text strong>{t('pages.users.temporaryPasswordLabel')}</Typography.Text>
        <Typography.Text
          code
          copyable={{ text: tempPassword ?? '' }}
          style={{ fontSize: 16, wordBreak: 'break-all' }}
        >
          {tempPassword}
        </Typography.Text>
        <Alert type="warning" showIcon title={t('pages.users.temporaryPasswordWarning')} />
      </Space>
    </Modal>
  );
}
